// File: cgp-idle-dialog.module.ts
// Author: Joseph M Diaz
// Date: 6/8/2017
// Desc: CGP Idle / Token Refresh timers and idle dialog.
// Other Contributors:

import { NgModule } from '@angular/core';

import { CgpIdleService } from './cgp-idle.service';
import { CgpIdleDialogComponent } from './cgp-idle-dialog/cgp-idle-dialog.component';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';

@NgModule({
    imports: [
        MatDialogModule,
        MatButtonModule
    ],
    exports: [
        CgpIdleDialogComponent
    ],
    declarations: [
        CgpIdleDialogComponent
    ],
    providers: [
        CgpIdleService
    ]
})
export class CgpIdleModule { }
